<template>
  <module-card
    v-bind="params"
    :loading="loading"
    :error="error"
    :permissions="permissions"
    :roles="roles"
    :errorText="errorText"
    :retryFunction="retryFunction"
    :segmentations="segmentations"
    @visibleChanged="$emit('visibleChanged', $event)"
  >
    <template slot="content">
      <div
        v-for="(item, i) in _items"
        class="faq-card__item"
        @click="selectFaq(item)"
        :key="i"
      >{{ item.question}}</div>
    </template>
    <template slot="actions">
      <v-btn
        class="slin-btn"
        @click="$router.push({ name: 'faq' })"
        :style="{ color: params.themeColor }"
      >
        <i class="bexsicon-faq-sm" />
        Saiba mais
      </v-btn>
    </template>
  </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card';
import {
  PROFILES,
  ROLES,
  UNIT,
  DOCS,
  SEGMENTATIONS
} from '../../utils/constants';
import enums from '@/utils/enums';
export default {
  components: {
    ModuleCard
  },
  computed: {
    segmentations() {
      if (!this.fromHome) {
        return [];
      }
      const product = this.$store.getters[UNIT.GET_SELECTED_PRODUCT];
      if (product) {
        const constructionStage = enums.constuctionStages[product.stage];
        switch (constructionStage) {
          case 'launch':
            return [
              SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
              SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
              SEGMENTATIONS.SFH__REHEARSE_STATUS,
              SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
              SEGMENTATIONS.INDIRECT__USER_ROLE,
              SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
              SEGMENTATIONS.LAUNCH__CONSTRUCTION_STAGE
            ];
            break;
          case 'inConstruction':
            return this.$store.getters[DOCS.HAS_LEGAL_DOCS]
              ? [
                  SEGMENTATIONS.INDIRECT__USER_ROLE,
                  SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                  SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE
                ]
              : [
                  SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                  SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                  SEGMENTATIONS.SFH__REHEARSE_STATUS,
                  SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                  SEGMENTATIONS.INDIRECT__USER_ROLE,
                  SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                  SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE
                ];
            break;
          case 'delivered':
            if (this.$store.getters[UNIT.GET_SELECTED].keyDeliveryDate) {
              return [
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE
              ];
            } else {
              return [
                SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE
              ];
            }
            break;
          default:
            return [];
        }
      } else {
        return null;
      }
    },
    _items() {
      return this.items.slice(0, 3);
    }
  },
  data() {
    return {
      permissions: [
        PROFILES.ADMIN_PROFILE,
        PROFILES.ADMIN_BEXS_PROFILE,
        PROFILES.ADMIN_HR_PROFILE,
        PROFILES.HR_PROFILE
      ],
      roles: [ROLES.CLIENT_ROLE]
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    error: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    fromHome: {
      type: Boolean
    },
    errorText: String,
    retryFunction: Function
  },
  methods: {
    selectFaq(faq) {
      this.$emit('faqSelected', faq);
    }
  }
};
</script>

<style lang="scss" scoped>
.faq-card {
  &__item {
    font-size: 0.9em;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
    border-bottom: 1px solid rgb(240, 240, 240);
    padding: 0.8em;
    cursor: pointer;

    &::before {
      content: '• ';
      color: var(--faq-color);
      font-weight: var(--font-weight);
    }

    &:hover {
      background-color: #f5f5f5;
    }

    &:last-of-type {
      margin-bottom: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/modules/FaqCard.vue